import AdminNav from '../AdminNav'

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNav />
      <div className="ml-64">
        {children}
      </div>
    </div>
  )
}